export default __webpack_public_path__ + "b08b6efad3a092bb2989a69da46dda8f.png";